import React from 'react'
import PropsType from 'prop-types'
import { Link } from 'gatsby'
import { Link as LinkScroll } from 'react-scroll'

import styles from './navigation.module.css'

const Navigation = props => {
  const renderNavigation = () => {
    return props.items.map(item => {
      if (item.url) {
        return (
          <Link
            className={styles.item}
            key={item.label}
            to={item.to}
            activeClassName={'active'}
          >
            {item.label}
          </Link>
        )
      }

      return (
        <LinkScroll
          className={styles.item}
          to={item.to}
          key={item.label}
          activeClass={'active'}
          spy={true}
          smooth={true}
          offset={50}
          duration={500}
        >
          {item.label}
        </LinkScroll>
      )
    })
  }

  return <nav className={styles.nav}>{renderNavigation()}</nav>
}

Navigation.propsType = {
  items: PropsType.Object,
}

export default Navigation
